import {
  BonusType,
  CustomerTransactionStatus,
  CustomerTransactionType,
  PaymentMethod,
} from 'common/api/autogenerated/client-area';

export const operationNameHashMap: Record<CustomerTransactionType, string> = {
  [CustomerTransactionType.DEPOSIT]: 'mobile:walletperasset.history.type.deposit',
  [CustomerTransactionType.WITHDRAWAL]: 'mobile:walletperasset.history.type.withdrawal',
  [CustomerTransactionType.BONUS]: 'mobile:walletperasset.history.type.bonus',
  [CustomerTransactionType.TRANSFER]: 'mobile:walletperasset.history.type.transfer',
  [CustomerTransactionType.WITHDRAWAL_REQUEST]: 'mobile:walletperasset.history.type.withdrawal',
  [CustomerTransactionType.EARN_TOP_UP]: 'mobile:walletperasset.history.type.earn_top_up',
  [CustomerTransactionType.EARN_REDEMPTION]: 'mobile:walletperasset.history.type.earn_redemption',
  [CustomerTransactionType.EARN_TERMINATION]: 'mobile:walletperasset.history.type.earn_termination',
  [CustomerTransactionType.EARN_REWARD]: 'mobile:walletperasset.history.type.earn_reward',
  [CustomerTransactionType.PAYMENT_CARD_PURCHASE_FEE]: '', // TODO add
  [CustomerTransactionType.PAYMENT_CARD_TOP_UP]: '', // TODO add
};

export const operationTypeHashMap: Record<BonusType, string> = {
  [BonusType.CRYPTO_REWARD]: 'mobile:walletperasset:bonus:type:cryptoreward',
  [BonusType.EXCHANGE_CASHBACK_REWARD]: 'mobile:walletperasset:bonus:type:exchangecashbackreward',
  [BonusType.REAL_MONEY]: 'mobile:walletperasset:bonus:type:realmoney',
  [BonusType.TRADE_MONEY]: 'mobile:walletperasset:bonus:type:trademoney',
  [BonusType.TRADING_CONDITIONS]: 'mobile:walletperasset:bonus:type:tradingconditions',
  [BonusType.REBATE_REAL_MONEY]: 'mobile:walletperasset:bonus:type:rebaterealmoney',
  [BonusType.REBATE_TRADE_MONEY]: 'mobile:walletperasset:bonus:type:rebatetrademoney',
  [BonusType.CRYPTO_MONEY]: 'mobile:walletperasset:bonus:type:cryptomoney',
  [BonusType.CRYPTO_REBATE]: 'mobile:walletperasset:bonus:type:cryptorebate',
  [BonusType.OTHER]: 'mobile:walletperasset:bonus:type:other',
};

export const operationMethodHashMap: Partial<Record<PaymentMethod | string, string>> = {
  [PaymentMethod.CREDIT_IN]: 'mobile:walletperasset:history:type:credit-in',
  [PaymentMethod.CREDIT_OUT]: 'mobile:walletperasset:history:type:credit-out',
};

export const statusNameHashMap: Record<CustomerTransactionStatus, string> = {
  [CustomerTransactionStatus.COMPLETED]: 'mobile:walletperasset.history.status.completed',
  [CustomerTransactionStatus.PENDING]: 'mobile:walletperasset.history.status.pending',
  [CustomerTransactionStatus.DECLINED]: 'mobile:walletperasset.history.status.declined',
};
